import * as types from './constants';
import api from '../_api'
const getHomeSlides = ({ commit }, params = {}) => {
  api.getHomeSlide(params)
    .then((response) => {
      commit(types.GET_HOMEPAGE_SLIDE, response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

export default {
    getHomeSlides
};